import type { AdminSubmission } from '../lib/types.ts';
import { complianceDocStats } from './complianceDocStats.ts';

// A read-only row of three cards summarising the company's compliance documents
// by expiry health. Colours match the ExpiryChip palette. Always renders all
// three (zeros included) for a stable layout.
export function ComplianceDocStats({
  submissions,
}: {
  submissions: (AdminSubmission | undefined)[];
}) {
  const stats = complianceDocStats(submissions);
  const cards = [
    {
      label: 'Current',
      value: stats.current,
      cls: 'border-emerald-200 bg-emerald-50 text-emerald-700',
    },
    {
      label: 'Expiring Soon',
      value: stats.expiringSoon,
      cls: 'border-amber-200 bg-amber-50 text-amber-700',
    },
    { label: 'Expired', value: stats.expired, cls: 'border-red-200 bg-red-50 text-red-700' },
  ];
  return (
    <div className="mb-4 grid grid-cols-3 gap-3">
      {cards.map((c) => (
        <div key={c.label} className={`rounded-lg border px-4 py-3 ${c.cls}`}>
          <div className="text-2xl font-semibold">{c.value}</div>
          <div className="text-xs font-medium uppercase tracking-wide">{c.label}</div>
        </div>
      ))}
    </div>
  );
}
